import { MDBAlert, MDBBtn, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { getStreamsNotification, updateGlobalSettings } from '../../../apiclients/streamsapi_bridge';
import SaveChanges from '../saveCancel';

function
    GlobalStreamsNotifcation({ register, setValue, errors, watch }) {
    const { t, i18n } = useTranslation();
   
    return (
        <>

            <div className="add-numbermain">
                <div className="tel-numbers">
                    <p>When the user is created</p>
                </div>
                <div className="phoneselect w-30">
                    <div>
                        <label className="switch">
                            <input className="form-control" type="checkbox" {...register("global_settings.streams_settings.user_create_notify")} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div className="add-numbermain">
                <div className="tel-numbers">
                    <p>When the user is deleted</p>
                </div>
                <div className="phoneselect w-30">
                    <div>
                        <label className="switch">
                            <input className="form-control" type="checkbox" {...register("global_settings.streams_settings.user_delete_notify")} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

        </>
    )
}

export default GlobalStreamsNotifcation
